<template>
  <hic-list-page ref="listPage" title="患者列表" :show-model-switch="condition.state == '已入住'"
    :card-model="condition.state == '已入住' && meta.cardModel" @cardModelChange="modelChange" :card-col-span="6"
    :entities="entities" :condition="condition" @load="page" :loading="meta.loading" header-height="6rem"
    keyword-placeholder="姓名、住院号、床位号" :search-fields="searchFields">
    <template slot="buttons">
      <el-switch v-if="condition.state == '已入住'" v-model="condition.ifShowOwnDept" style="margin-left: 20px"
        @change="page" :active-text="$utils.Dict.text(user.deptCode, 'Dept')" inactive-text="我的"
        inactive-color="#ff4949" active-color="#13ce66"></el-switch>
    </template>
    <template slot="search">
      <!-- <template v-if="condition.state == '已入住' && setting.isSimple">
        <hic-text-selector dict-type="AllergyDrugs" v-model="dxCon.allergyDrugs" size="small" placeholder="请选择过敏史"
          @change="page" style="width: 150px;margin-right: 1rem;" clearable></hic-text-selector>
        <hic-dict-selector dict-type="TargetGrade" v-model="dxCon.targetGrade" size="small" placeholder="请选择目标分级"
          @change="page" style="width: 150px;margin-right: 1rem;" clearable></hic-dict-selector>
        <hic-text-selector dict-type="Epidemic" v-model="dxCon.epidemic" size="small" placeholder="请选择传染病"
          @change="page" style="width: 150px;margin-right: 1rem;" clearable></hic-text-selector>
      </template> -->
      <el-date-picker @change="changeDate" style="width: 230px" size="small" v-model="date" type="daterange"
        range-separator="至" start-placeholder="入院日期" end-placeholder="结束日期"></el-date-picker>
      <hic-dict-selector v-model="condition.wardCode" dict-type="IpWard" placeholder="病区" class="condition-input"
        size="small" @change="page"></hic-dict-selector>
    </template>
    <template slot="extend">
      <el-tabs v-model="condition.state" @tab-click="page">
        <el-tab-pane label="在院患者" name="已入住"></el-tab-pane>
        <el-tab-pane v-if="!setting.isSimple" label="会诊患者" name="会诊"></el-tab-pane>
        <el-tab-pane label="离院患者" name="已离院"></el-tab-pane>
        <el-tab-pane v-if="!setting.isSimple" label="已结算患者" name="已结算"></el-tab-pane>
      </el-tabs>
    </template>
    <el-table-column v-if="condition.state == '已入住'" align="left" sortable="custom" label="床位" prop="bedNo"
      min-width="150" key="bedNo">
      <template slot-scope="{ row }">
        <el-badge :value="row.news" class="item" :hidden="!row.news" style="margin: 0.5rem 0">
          <el-link type="primary" @click="openPatient(row, 'patientAdvice')" class="bold-title">
            {{ row.bedNo }}
          </el-link>
        </el-badge>
      </template>
    </el-table-column>
    <el-table-column v-if="setting.isSimple" label="操作" align="left" width="200" key="action">
      <template slot-scope="{ row }">
        <el-dropdown slot="tools" type="text" plain size="mini" class="primary" @command="(e) => exeCmd(e, row)">
          <el-button type="text" icon="el-icon-notebook-2" @click="openPatient(row, 'patientEmr')">病历 <i
              class="el-icon-arrow-down el-icon--right" /></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="row.state == '已入住'" icon="el-icon-box" class="warning"
              command="changeBed">调床位</el-dropdown-item>
            <el-dropdown-item class="info" command="historyBed">
              <el-popover placement="right" title="" trigger="click">
                <el-row class="center info bottom-pad">
                  <b>共 {{ logEngities.items.length }} 条</b>
                </el-row>
                <el-scrollbar style="height: 20rem">
                  <el-timeline style="margin-left: -1rem; padding: 0 2rem">
                    <el-timeline-item v-for="(log, index) in logEngities.items" :key="index" :timestamp="bedInfo(log)"
                      :type="log.type == '入院' ? 'warning ' : log.type == '调床' ? 'success' : 'danger'">
                      <span>{{ log.type }} ：</span> <span>{{ log.startTime | fmtDate }}</span> <span
                        v-if="log.endTime">至 {{
    log.endTime | fmtDate }} </span> <span v-else>至 今</span>
                    </el-timeline-item>
                  </el-timeline>
                </el-scrollbar>
                <div slot="reference"><i class="el-icon-warning-outline"></i>历史床位</div>
              </el-popover>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-table-column>
    <el-table-column label="姓名" prop="patientName" align="left" width="200" key="patientName">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="openPatient(row)">
          {{ row.patientName }}
        </el-link>
      </template>
    </el-table-column>
    <el-table-column align="center" v-if="condition.state == '已入住'" label="护理级别" prop="nursingGrade" key="nursingGrade">
      <template slot-scope="{ row }">
        <el-tag v-if="row.nursingGrade" type="warning" size="small" hit>{{ row.nursingGrade }}</el-tag>
      </template>
    </el-table-column>

    <el-table-column align="right" sortable="custom" label="年龄" prop="patientBirthday" key="patientBirthday">
      <template slot-scope="{ row }">
        {{ row.patientAge }}
      </template>
    </el-table-column>
    <el-table-column align="center" label="性别" prop="patientGender" key="patientGender">
      <template slot-scope="{ row }">{{ row.patientGender | dictText("Gender") }}</template>
    </el-table-column>
    <el-table-column align="center" label="病区" prop="wardCode" key="wardCode">
      <template slot-scope="{ row }">
        {{ row.wardCode | dictText("IpWard") }}
      </template>
    </el-table-column>
    <el-table-column align="center" label="住院医师" prop="doctorName" key="doctorName"></el-table-column>
    <el-table-column align="center" label="责任护士" prop="nurseName" key="nurseName"></el-table-column>
    <el-table-column align="center" v-if="condition.state == '已入住'" label="主要诊断" prop="diagnosisName"
      key="diagnosisName"></el-table-column>
    <el-table-column align="center" v-if="condition.state == '已入住' && setting.isSimple" width="120" label="过敏史" prop="allergyDrugs"
      column-key="allergyDrugs" :filter-multiple="false"
      :filters="dict.AllergyDrugs.map(el => { return { text: el.text, value: el.text } })">
      <template slot-scope="{ row }">
        {{ row.allergic || row.allergyDrugs }}
      </template>
    </el-table-column>
    <el-table-column align="center" v-if="condition.state == '已入住' && setting.isSimple" width="120" label="目标分级" prop="targetGrade"
      column-key="targetGrade" :filter-multiple="false"
      :filters="dict.TargetGrade">
      <template slot-scope="{ row }">
        {{ row.targetGrade | dictText('TargetGrade')}}
      </template>
    </el-table-column>
    <el-table-column align="center" v-if="condition.state == '已入住' && setting.isSimple" width="120" label="传染病" prop="epidemic"
      column-key="epidemic" :filter-multiple="false"
      :filters="dict.Epidemic.map(el => { return { text: el.text, value: el.text } })">
      <template slot-scope="{ row }">
        {{ row.epidemic }}
      </template>
    </el-table-column>
    <el-table-column align="right" sortable="custom" width="120" label="在院天数" prop="startDate" key="days">
      <template slot-scope="{ row }">{{ inDays(row) }}</template>
    </el-table-column>
    <el-table-column align="right" width="120" label="术后天数" prop="ordinaryBedDays"
      key="ordinaryBedDays"></el-table-column>
    <el-table-column align="right" v-if="condition.state == '已入住'" width="120" label="余额" prop="balance" key="balance">
      <template slot-scope="{ row }">
        <span :class="(row.balance || 0) <= 0 ? 'danger' : 'success'">￥{{ (row.balance || 0) | fmtFloat(2) }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" width="120" label="收费类别" prop="ipType" key="ipType"></el-table-column>
    <el-table-column align="center" sortable="custom" width="100px;" label="入院日期" prop="startDate" key="startDate">
      <template slot-scope="{ row }">
        {{ row.startDate | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column align="center" v-if="condition.state == '已离院' || condition.state == '已结算'" sortable="custom"
      width="100px;" label="离院日期" prop="startDate" key="endDate">
      <template slot-scope="{ row }">
        {{ row.endDate | fmtDate }}
      </template>
    </el-table-column>

    <!-- <el-table-column align="center" key="leaveMode" v-if="condition.state == '已结算'" label="离院方式" prop="leaveMode"></el-table-column>
    <el-table-column align="center" key="diagnosisName" v-if="condition.state == '已结算'" label="出院诊断" prop="diagnosisName"></el-table-column>
    <el-table-column align="center" sortable="custom" key="endDate" v-if="condition.state == '已结算'" width="150px;" label="出院时间" prop="endDate"></el-table-column> -->

    <template #card="{ row }">
      <hic-hospitalization-card :entity="row" @click="openPatient(row, 'patientAdvice')"
        @diagnosisClick="openPatient(row, 'patientDiagnosis')" :show-diagnosis-link="!setting.isSimple">
        <!-- <el-link type="primary" icon="el-icon-notebook-2" @click="openPatient(row, 'patientAdvice')" slot="tools"> 医嘱</el-link> -->
        <el-dropdown slot="tools" type="text" plain size="mini" class="primary" @command="(e) => exeCmd(e, row)">
          <el-button type="text" icon="el-icon-notebook-2" @click="openPatient(row, 'patientAdvice')">医嘱 <i
              class="el-icon-arrow-down el-icon--right" /></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-box" class="warning" command="changeBed">调床位</el-dropdown-item>

            <el-dropdown-item class="info" command="historyBed">
              <el-popover placement="right" title="" trigger="click">
                <el-row class="center info bottom-pad">
                  <b>共 {{ logEngities.items.length }} 条</b>
                </el-row>
                <el-scrollbar style="height: 20rem">
                  <el-timeline style="margin-left: -1rem; padding: 0 2rem">
                    <el-timeline-item v-for="(log, index) in logEngities.items" :key="index" :timestamp="bedInfo(log)"
                      :type="log.type == '入院' ? 'warning ' : log.type == '调床' ? 'success' : 'danger'">
                      <span>{{ log.type }} ：</span> <span>{{ log.startTime | fmtDate }}</span> <span
                        v-if="log.endTime">至 {{
    log.endTime | fmtDate }} </span> <span v-else>至 今</span>
                    </el-timeline-item>
                  </el-timeline>
                </el-scrollbar>
                <div slot="reference"><i class="el-icon-warning-outline"></i>历史床位</div>
              </el-popover>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </hic-hospitalization-card>
    </template>
    <!-- <patient-card :hospitalization="entity" :visible.sync="meta.showPatient" :default-tab="meta.defaultTab"></patient-card> -->
    <hic-hospitalization-dialog :entity="entity" :visible.sync="meta.showPatient" :default-tab="meta.defaultTab"
      :condition="condition" diagnosis-tab-name="patientDiagnosis" @close="onDlgClose">
      <template #menus>
        <el-menu-item index="patientAdvice">医嘱管理</el-menu-item>
        <el-menu-item index="patientEmr">电子病历</el-menu-item>
        <el-menu-item v-if="!setting.isSimple" index="patientDiagnosis">诊断信息</el-menu-item>
        <el-menu-item v-if="!setting.isSimple" index="patientSurgery">手术管理</el-menu-item>
        <el-menu-item v-if="!setting.isSimple" index="patientConsult">会诊管理</el-menu-item>
        <el-menu-item v-if="!setting.isSimple" index="patientExamine">检查检验报告</el-menu-item>
        <el-menu-item index="patientVitalSign">生命体征</el-menu-item>
        <el-menu-item index="patientInfo">患者概览</el-menu-item>
      </template>
      <template #main="{ data }">
        <Emr ref="emr" v-show="$route.name == 'patientEmr'" :entity="data" :display="meta.showPatient"></Emr>
      </template>
    </hic-hospitalization-dialog>
    <hic-hospitalization-beds-dialog :visible.sync="meta.showBed" :hospitalization="entity"
      :hide-wrap="setting.isSimple" />
  </hic-list-page>
</template>
<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  components: {
    Emr: () => import("./card/emr.vue"),
  },
  data() {
    return {
      meta: {
        loading: false,
        showPatient: false,
        cardModel: false,
        defaultTab: null,
        showBed: false,
        showBedLog: false,
      },
      date: null,
      condition: {
        state: "已入住",
        ifShowOwnDept: true,
        date: "",
        keyword: "",
        pageSize: 100,
        sort: "bedNo",
        asc: true,
      },
      entities: {},
      entity: {},
      logEngities: { items: [] },
      beds: [],
      dxCon: {
        crb: false,
        allergyDrugs: null,
        targetGrade: null
      }
    };
  },
  computed: {
    ...mapGetters(["user", "dict", "setting"]),
    searchFields() {
      return [
        { label: "姓名", prop: "patientName", type: "input" },
        { label: "床位", prop: "bedNo", type: "input" },
        { label: "护理", prop: "nursingGrade", type: "input", hide: true },
        { label: "年龄", prop: "patientAge", hide: true },
        { label: "性别", prop: "patientGender", type: "dict", options: this.dict.Gender },
        { label: "病区", prop: "wardCode", type: "dict", options: this.dict.IpWard },
        { label: "住院医师", prop: "doctorName", type: "input" },
        { label: "责任护士", prop: "nurseName", type: "input" },
        { label: "主要诊断", prop: "diagnosisName", hide: true },
        { label: "过敏史", prop: "allergyDrugs", hide: true },
        { label: "在院天数", prop: "startDate", hide: true },
        { label: "术后天数", prop: "ordinaryBedDays", hide: true },
        { label: "余额", prop: "balance", hide: true },
        { label: "收费类别", prop: "ipType", hide: true },
      ];
    },
  },

  methods: {
    openPatient(row, tbName) {
      this.meta.defaultTab = tbName;
      this.entity = row;
      this.meta.showPatient = true;
    },
    changeDate(d) {
      if (d) {
        this.condition.startDateSt = this.$utils.Fmt.startDatetime(d[0]);
        this.condition.startDateEd = this.$utils.Fmt.endDatetime(d[1]);
      } else {
        this.condition.startDateSt = null;
        this.condition.startDateEd = null;
      }

      this.page();
    },
    page() {
      let model = this.$utils.Repository.get("resident_hospitalization_model");
      if (model != undefined) {
        this.meta.cardModel = model;
      }
      try {
        this.meta.loading = true;
        (() => {
          if (this.condition.state == "会诊") {
            let con = this.$utils.Obj.clone(this.condition);
            delete con.state;
            return api.Consultation.query(con);
          }
          this.condition.deptCode = this.user.deptCode;
          if (!this.condition.ifShowOwnDept) {
            this.condition.doctorCode = this.user.code;
          } else {
            this.condition.doctorCode = null;
          }
          if (this.condition.state == '已入住') {
            let _keys = []

            // console.log('this.dxCon===', this.dxCon)

            // if (this.dxCon.epidemic && this.dxCon.epidemic.length > 0) this.condition.epidemic = this.dxCon.epidemic //传染病
            // else delete this.condition.epidemic
            // if (this.dxCon.allergyDrugs && this.dxCon.allergyDrugs.length > 0) this.condition.allergyDrugs = this.dxCon.allergyDrugs //药物过敏
            // else delete this.condition.allergyDrugs
            // if (this.dxCon.targetGrade && this.dxCon.targetGrade.length > 0) this.condition.targetGrade = this.dxCon.targetGrade //目标分级
            // else delete this.condition.targetGrade


            // if(this.dxCon.gms) _keys.push('patientAllergyDrugs')
            // if(_keys.length > 0) this.condition.notNulls = _keys.join(',')
            // else delete this.condition.notNulls
          }
          console.log('this.condition===', this.condition)
          if (this.condition.sort == 'patientBirthday' || this.condition.sort == 'startDate') this.condition.asc = !this.condition.asc
          return api.Hospitalization.query(this.condition);
        })()
          .then((res) => {
            this.entities = res;
            this.queryNews();
          })
          .catch((err) => {
            this.$message.error(err?.message || err);
          });
      } catch (err) {
        this.$message.error(err?.message || err);
      } finally {
        this.meta.loading = false;
      }
    },
    inDays({ startDate, endDate }) {
      let days = this.$utils.Dt.span(startDate, endDate || this.$utils.Dt.now(), "d");
      let years = Math.trunc(days / 365);
      days = days % 365;
      return years ? `${years}年${days}天` : `${days}天`;
    },
    modelChange(model) {
      this.$utils.Repository.set("resident_hospitalization_model", model);
    },
    exeCmd(cmd, row) {
      if (cmd == "changeBed") {
        this.entity = row;
        this.meta.showBed = true;
      } else if (cmd == "historyBed") {
        this.historyBed(row);
      }
    },
    historyBed(row) {
      this.meta.showBedLog = true;
      api.BedLog.query({ hospitalizationId: row.id, sort: "id", asc: false })
        .then((res) => {
          this.logEngities = res;
          return api.Bed.query({ ids: res.items.map((l) => l.bedId) });
        })
        .then((res) => {
          this.beds = res.items;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.meta.showBedLog = false;
        });
    },
    bedInfo(log) {
      if (this.beds) {
        let days = this.$utils.Dt.span(log.startTime, log.endTime || this.$utils.Dt.now(), "d");
        let bed = this.beds.find((i) => i.id == log.bedId);
        if (bed) {
          return `${bed.no} ${this.$utils.Dict.text(bed.type, "BedType")}床 ${days}天`;
        }
      }
      return null;
    },
    onDlgClose() {
      if (this.entity.state == "已离院" || this.entity.state == "已结算") {
        this.meta.showPatient = false;
        this.$router.replace({ name: 'patient' });
        return
      }

      this.$message.success("正在保存病历...");
      this.$utils.log("patient dialog close");
      this.$refs.emr.save();

      setTimeout(() => {
        this.meta.showPatient = false;
        this.$router.replace({ name: 'patient' });
      }, 1000);
    },
    queryNews() {
      if (this.entities.items.length) {
        api.Advice.query({
          deptCode: this.user.deptCode,
          state: "退回",
          ifDetail: false,
          isMaster: true,
        }).then((res) => {
          if (res.items.length) {
            this.entities.items.forEach((item) => {
              this.$set(item, "news", res.items.filter((a) => a.hospitalizationId == item.id).length);
            });
          }
        });
      }
    },
  },
};
</script>
